(() => {
    class FaqSection extends HTMLElement {
      constructor() {
        super();
        this.handleAccordion();
        
      }
      
      handleAccordion() {
        const listTab = this.querySelectorAll(".Accordion__Button");
        listTab.forEach((currentTab) => {
            currentTab.addEventListener("click", () => {
            listTab.forEach((tab) => {
                if (tab !== currentTab) {
                tab.closest(".Accordion__Item")?.querySelector('.Accordion__Collapse')?.classList.remove("Show");
                tab.closest(".Accordion__Item")?.querySelector('.Accordion__Button')?.classList.add("Collapsed");
                }
            });
            });
        });
      }
    }
  
    // Only register if not already defined
    if (!customElements.get("faq-section")) {
      customElements.define("faq-section", FaqSection);
    }
  })();
  